(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modmount-height-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mmPerInch = 25.4;

    function initCalculator(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('[data-calculator-form]');
      const parser = new DOMParser();
      const labels = Object.fromEntries(
        Object.entries(JSON.parse(root.dataset.calculatorLabels)).map(([key, value]) => [
          key,
          parser.parseFromString(value, 'text/html').body.textContent,
        ])
      );
      const pieces = [...root.querySelectorAll('[data-piece]')];
      const unitButtons = [...root.querySelectorAll('[data-unit]')];
      const unitLabels = [...root.querySelectorAll('[data-unit-label]')];
      let unit = 'mm';

      const output = {
        title: root.querySelector('[data-result-title]'),
        base: root.querySelector('[data-result-base]'),
        mount: root.querySelector('[data-result-mount]'),
        spacers: root.querySelector('[data-result-spacers]'),
        total: root.querySelector('[data-result-total]'),
        converted: root.querySelector('[data-result-converted]'),
        baseLayer: root.querySelector('[data-stack-base]'),
        mountLayer: root.querySelector('[data-stack-mount]'),
        spacerLayer: root.querySelector('[data-stack-spacer]')
      };

      const readMm = input => {
        const value = Number.parseFloat(input.value);
        if (!Number.isFinite(value) || value < 0) return null;
        return unit === 'mm' ? value : value * mmPerInch;
      };

      const format = mm => {
        if (!Number.isFinite(mm)) return '-';
        const shown = unit === 'mm' ? mm : mm / mmPerInch;
        return `${shown.toFixed(unit === 'mm' ? 2 : 3)} ${unit}`;
      };

      function selectedName(piece) {
        const select = piece.querySelector('[data-piece-select]');
        const option = select.selectedOptions[0];
        return option?.value ? option.textContent.trim() : '';
      }

      function syncInputState(piece) {
        const select = piece.querySelector('[data-piece-select]');
        const input = piece.querySelector('[data-piece-height]');
        const selectedValue = select.selectedOptions[0]?.value || '';
        input.readOnly = !selectedValue.startsWith('Manual');
      }

      function calculate() {
        const values = pieces.map(piece => readMm(piece.querySelector('[data-piece-height]')));
        const [base, mount, spacerOne, spacerTwo] = values;
        const spacerValues = [spacerOne, spacerTwo];
        const spacersComplete = pieces.slice(2).every((piece, index) => {
          const selectedHeight = piece.querySelector('[data-piece-select]').selectedOptions[0]?.dataset.height;
          const needsValue = selectedHeight === '' || Number.parseFloat(selectedHeight) > 0;
          return !needsValue || spacerValues[index] !== null;
        });
        const spacerTotal = spacerValues.reduce((total, value) => total + (value || 0), 0);
        const requiredComplete = base !== null && mount !== null && spacersComplete;

        pieces.forEach((piece, index) => {
          const input = piece.querySelector('[data-piece-height]');
          const invalid = input.value.trim() !== '' && values[index] === null;
          input.setAttribute('aria-invalid', String(invalid));
        });

        output.base.textContent = format(base);
        output.mount.textContent = format(mount);
        output.spacers.textContent = spacersComplete ? format(spacerTotal) : labels.enter_height;
        output.baseLayer.textContent = selectedName(pieces[0]) || labels.base;
        output.mountLayer.textContent = selectedName(pieces[1]) || labels.mount;
        output.spacerLayer.hidden = spacerTotal <= 0;
        output.spacerLayer.textContent = spacerTotal > 0
          ? labels.spacer_result.replace('__HEIGHT__', format(spacerTotal))
          : labels.vertical_spacer;

        if (!requiredComplete) {
          output.title.textContent = base === null || mount === null ? labels.required_heights : labels.enter_spacer_height;
          output.total.textContent = '-';
          output.converted.textContent = '';
          return;
        }

        const total = base + mount + spacerTotal;
        const otherUnit = unit === 'mm' ? `${(total / mmPerInch).toFixed(3)} in` : `${total.toFixed(2)} mm`;
        output.title.textContent = labels.calculated;
        output.total.textContent = format(total);
        output.converted.textContent = otherUnit;
      }

      function applySelection(piece) {
        const select = piece.querySelector('[data-piece-select]');
        const input = piece.querySelector('[data-piece-height]');
        const height = select.selectedOptions[0]?.dataset.height;
        if (height === undefined || height === '') {
          input.value = '';
          input.placeholder = labels.enter_value;
        } else {
          const mm = Number.parseFloat(height);
          input.value = unit === 'mm' ? String(mm) : (mm / mmPerInch).toFixed(4);
          input.placeholder = '';
        }
        syncInputState(piece);
        calculate();
      }

      function changeUnit(nextUnit) {
        if (nextUnit === unit) return;
        pieces.forEach(piece => {
          const input = piece.querySelector('[data-piece-height]');
          const value = Number.parseFloat(input.value);
          if (!Number.isFinite(value)) return;
          const mm = unit === 'mm' ? value : value * mmPerInch;
          input.value = nextUnit === 'mm' ? mm.toFixed(2) : (mm / mmPerInch).toFixed(4);
        });
        unit = nextUnit;
        unitLabels.forEach(label => { label.textContent = unit; });
        unitButtons.forEach(button => {
          const active = button.dataset.unit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        calculate();
      }

      pieces.forEach(piece => {
        piece.querySelector('[data-piece-select]').addEventListener('change', () => applySelection(piece));
        piece.querySelector('[data-piece-height]').addEventListener('input', calculate);
      });
      unitButtons.forEach(button => button.addEventListener('click', () => changeUnit(button.dataset.unit)));
      form.addEventListener('reset', () => window.setTimeout(() => {
        unit = 'mm';
        unitLabels.forEach(label => { label.textContent = 'mm'; });
        unitButtons.forEach(button => {
          const active = button.dataset.unit === 'mm';
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        pieces.forEach(syncInputState);
        calculate();
      }, 0));

      pieces.forEach(syncInputState);
      calculate();
    }

    document.querySelectorAll('[data-modmount-calculator]').forEach(initCalculator);
    document.addEventListener('shopify:section:load', event => initCalculator(event.target.querySelector('[data-modmount-calculator]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
